import { Transaction } from './types'

export const convertPoints = (transactions: Transaction[] = []): Transaction[] =>
  transactions.map(({ points, ...transaction }) => {
    return {
      ...transaction,
      points: transaction.transactionTypeCode === 'REDEEM' ? points * -1 : points,
    }
  })

export const getResetOfPointsTransaction = (
  transactions: Transaction[] = [],
): Transaction | undefined => {
  if (!transactions.length) {
    return undefined
  }

  return transactions.find(({ activitySubType }) => activitySubType.includes('ZA01'))
}

export const getTransactionsAfterResetOfPoints = (
  transactions: Transaction[] = [],
  resetTransactionDateAndTime?: string,
): Transaction[] => {
  if (!transactions.length) {
    return []
  }

  if (!resetTransactionDateAndTime) {
    return transactions
  }

  const resetPointsDate = new Date(resetTransactionDateAndTime).valueOf()
  return transactions.filter(
    ({ transactionDateAndTime }) =>
      new Date(transactionDateAndTime).valueOf() - resetPointsDate > 0,
  )
}

export const getTransactionsBeforeResetOfPoints = (
  transactions: Transaction[] = [],
  resetTransactionDateAndTime?: string,
): Transaction[] => {
  if (!transactions.length || !resetTransactionDateAndTime) {
    return []
  }

  const resetPointsDate = new Date(resetTransactionDateAndTime).valueOf()
  return transactions.filter(
    ({ transactionDateAndTime }) =>
      new Date(transactionDateAndTime).valueOf() - resetPointsDate < 0,
  )
}
